module.exports = __webpack_public_path__ + "img/clg-block-bg-2.1a9d8df3.png";